import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./ImportModal.module.css";
import { IoIosClose } from "react-icons/io";
import {
  uploadContactsFileToMongo,
  fetchContactsFileFromMongo
} from "../../../Services/contacts";
import { useDispatch,connect } from "react-redux";
import Loading from "../../Loading/Loading";
import { motion } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import {themeColors} from "../../theme";
import { uploadFileToS3,getDateAndTimeString } from "../../../Values/utils";
import { v4 as uuidv4 } from 'uuid';
import { showSnackbarAction } from "../../../Redux/actions";
import { googleAnalyticsCTAClick } from "../../../Services/users";

type props = {
  open: boolean;
  close: () => void;
  organization_id: string;
  history: any;
  usersList: any[];
  user: any;
  theme: any;
  authToken:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const NewImportContactModal: FunctionComponent<props> = ({
  open,
  close,
  organization_id,
  history,
  usersList,
  user,
  theme,
  authToken
}) => {
  const [load, setLoad] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const dispatcher = useDispatch();

  useEffect(() => {
    if (organization_id) {

      fetchContactsFileFromMongo(
        organization_id,
        user.uid,
        "Contacts",
        (data: any) => setUploadedFiles(data),
        // dispatcher,
        // authToken
      );
    }
  }, [organization_id]);
  const upload = async (file: any) => {
    try{
      setLoad(true);
    const requestId = uuidv4();
    let url = await uploadFileToS3(file,requestId);
    await uploadContactsFileToMongo(url    ,organization_id,
      user.uid,
      dispatcher,
      (data: boolean) => setLoad(data),
      authToken,
      requestId
    )
    }catch(error:any){
      dispatcher(showSnackbarAction(error.response.data.message, 'error'));
      setLoad(false);
     }
  };

  const containerStyles = { backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  const tdStyles = {
    backgroundColor:theme?themeColors.tdBackgroundColor:themeColors.tdBackgroundColorDark,
    color:theme?themeColors.textPrimary:themeColors.textPrimaryDark,
  }
  const thStyles = {
    backgroundColor:theme ? themeColors.thBackgroundColor:themeColors.thBackgroundColorDark,    color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
  }
  return (
    <>
           <Backdrop>
        <motion.div
        key="modal"
        className="card px-4 py-2 shadow rounded"
        style={{position: "absolute",
        ...containerStyles}}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
      {load === true && <Loading />}
      <div className={styles.Imagechild}>
        {load === true && <Loading />}
        <div className={styles.cross} onClick={close}>
          <IoIosClose size={35} color={"#808080"} />
        </div>
        <h5 
        // className={styles.contactForm}
        >Import Data for "Contact Form"</h5>
        <div className={styles.tableBox}>
          <table className={styles.table}>
            <thead className={styles.head}>
              <tr>
                <th className={styles.th} style={thStyles}>Sno.</th>
                <th className={styles.th} style={thStyles}>Request Id</th>
                <th className={styles.th} style={thStyles}>Created At</th>
                <th className={styles.th} style={thStyles}>Status</th>
                <th className={styles.th} style={thStyles}>Upload Count</th>
                <th className={styles.th} style={thStyles}>Uploaded File</th>
                <th className={styles.th} style={thStyles}>Processed File</th>
              </tr>
            </thead>
            <tbody>
              {uploadedFiles.length > 0 && uploadedFiles.map((item: any, index: number) => (
                <tr key={index} className={styles.no}>
                  <td className={styles.td} style={tdStyles}>{index + 1}</td>
                  <td className={styles.td} style={tdStyles}>{item.request_id}</td>
                  <td className={styles.td} style={tdStyles}>
                    {/* {moment(item.created_at.toDate()).format("MM/DD/YY HH:mm")} */}
                    {/* {getDateAndTimeString(item.created_at)}; */}
                    {
                      getDateAndTimeString(
                        item.created_at,
                       "MM/DD/YY HH:mm"
                      )
                    }
                  </td>
                  <td className={styles.td} style={tdStyles}>{item.status}</td>
                  <td className={styles.td} style={tdStyles}>{item.upload_count}</td>
                  <td className={styles.td} style={tdStyles}>
                    <a href={item.file_url}>Uploaded File</a>
                  </td>

                  <td className={styles.td} style={tdStyles}>
                    {item.response_url !== "" && (
                      <a href={item.response_url}>Processed File</a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.uploadButton}>
            <a
              style={{ textDecoration: "none", color: "#fff" }}
              href="https://read-pro.s3.amazonaws.com/readpro/2024/07/d6d45966-fc8c-45ea-b8a2-9314f258ef79/66a0d9c282a8f7510c0a6379-ContactImportTemplate.csv"
              onClick={()=>{googleAnalyticsCTAClick("Contact Download Template","Contact Screen",user)}}
            >
              Download Template
            </a>
          </div>
          <label htmlFor="file-input" className={styles.uploadButton}>
            Upload File
          </label>
          <input
            id="file-input"
            className={styles.select}
            type="file"
            accept=".csv"
            onChange={(e: any) => {
              upload(e.target.files[0])}}
              onClick={()=>{ googleAnalyticsCTAClick("Contact Upload File","Contact Screen",user)}}
          />
        </div>
        <div style={{textAlign: "center",marginTop:"1rem"}}>
                    <p><i className="fas fa-info-circle"></i>  Only .csv file type is supported.</p>
                    <p style={{marginTop:"-1rem"}}><i className="fas fa-info-circle"></i>  Please ensure filling all the mandatory fields.</p>
                </div>
      </div>
      </motion.div>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(NewImportContactModal);

